import { Component, Input, OnInit } from '@angular/core';
import { TranslationService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-read-mymail-container',
  templateUrl: 'read-mymail-container.component.html',
})
export class ReadMymailContainerComponent implements OnInit {
  @Input() selectedMail: string;
  redirectUrl: string;

  constructor(private translationService: TranslationService) {}

  ngOnInit() {
    this.redirectUrl = this.translationService.getTranslatedValueFor(
      'read.mymail.redirect.url',
    );
  }
}
